import { Controller } from "@hotwired/stimulus"

// Same interaction pattern as Trends config: gear toggles a threshold table; reset restores default.
export default class extends Controller {
  static targets = ["detail", "thresholdInput"]

  connect() {
    this.thresholdInputTargets.forEach((input) => this.syncResetButton(input))
  }

  toggleDetails(event) {
    const recordKey = event.currentTarget.dataset.recordKey

    this.detailTargets.forEach((detail) => {
      if (detail.dataset.recordKey === recordKey) {
        if (detail.classList.contains("d-none")) {
          detail.classList.remove("d-none")
          detail.classList.add("d-block")
        } else {
          detail.classList.remove("d-block")
          detail.classList.add("d-none")
        }
      } else {
        detail.classList.remove("d-block")
        detail.classList.add("d-none")
      }
    })
  }

  resetToDefault(event) {
    event.preventDefault()

    const row = event.currentTarget.closest("tr")
    const input = row?.querySelector("[data-record-book-config-target='thresholdInput']")
    if (!input) return

    input.value = input.dataset.defaultValue || ""
    this.syncResetButton(input)
  }

  updateResetVisibility(event) {
    this.syncResetButton(event.currentTarget)
  }

  syncResetButton(input) {
    const row = input.closest("tr")
    if (!row) return

    const defaultValue = (input.dataset.defaultValue ?? "").toString()
    const currentValue = input.value.trim()
    const resetCell = row.querySelector("td:last-child")
    let resetButton = row.querySelector("[data-record-book-config-target='resetButton']")

    if (currentValue !== "" && currentValue !== defaultValue) {
      if (!resetButton) {
        resetCell.insertAdjacentHTML("beforeend", this.resetButtonHtml())
      }
    } else if (resetButton) {
      resetButton.remove()
    }
  }

  resetButtonHtml() {
    return `
      <button type="button"
              class="btn btn-clear border-0 color-fanword-blue p-0"
              data-record-book-config-target="resetButton"
              data-action="click->record-book-config#resetToDefault"
              aria-label="Reset to default">
        <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
      </button>
    `
  }
}
